module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_mjolby-32a0f368a805acd7aeffd102251269fd.png";